export default __webpack_public_path__ + "static/media/wolframalpha.24726d34.svg";